import { render, staticRenderFns } from "./serviceProviderList.vue?vue&type=template&id=39dc744d&scoped=true&"
import script from "./serviceProviderList.vue?vue&type=script&lang=js&"
export * from "./serviceProviderList.vue?vue&type=script&lang=js&"
import style0 from "./serviceProviderList.vue?vue&type=style&index=0&id=39dc744d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc744d",
  null
  
)

export default component.exports